export default "__VITE_ASSET__DA3WgyO0__"